import styled from "styled-components";

const TableWrap = styled.div`
	> table {
		th {
			height: 50px;
			padding: 0 10px;
			text-align: left;
		}
		td {
			height: 50px;
			padding: 0 10px;
			text-align: left;
			vertical-align: top;
			> div {
				padding: 15px 0;
			}
		}
		tr {
			&:first-child {
				td {
					vertical-align: middle;
				}
			}
			&:last-child {
				th:not(:first-child) {
					text-align: center;
					font-size: 13px;
				}
				td {
					padding: 0;
					height: 35px;
					> div {
						padding: 0 10px;
					}
				}
			}
		}
	}
`;
const ProductExplain = styled.div`
	font-size: 16px;
	color: var(--emp-color);
	vertical-align: top;
`;
const ProductPrice = styled.div`
	width: 100%;
	height: auto;
	font-size: 16px;
	text-align: right;
	vertical-align: middle;
	color: var(--red-color);
	em {
		font-family: "PT-medium";
	}
`;
const BtnBlock = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 40px;
`;

export {ProductExplain, ProductPrice, TableWrap, BtnBlock};
